import produce from "immer";
import { React, ProductTile, Text } from "xolabot-sdk";
import { store } from "../store";

const spinnerStyle = {
    display: "inline-block",
    lineHeight: "16px",
    width: 40,
    height: 34,
    fontWeight: "bold",
    color: "#999",
    backgroundColor: "#fff",
    textAlign: "center",
    verticalAlign: "middle",
    touchAction: "manipulation",
    cursor: "pointer",
    border: "1px solid #eeeeee",
    whiteSpace: "nowrap",
    borderRadius: "2px",
    padding: "4px 3px",
    verticalAlign: "middle",
};

export const QuantityAddon = ({ addon }) => {
    const { getState, setState } = store;
    const [quantity, setQuantity] = React.useState(0);

    const handleDecrease = (e) => {
        const { addons } = getState();
        if (quantity > 0) {
            setState({
                addons: produce(addons, (draft) => {
                    const newQuantity = quantity - 1;
                    draft[addon.id].quantity = newQuantity;
                    setQuantity(newQuantity);
                }),
            });
        }
    };

    const handleIncrease = (e) => {
        const { addons } = getState();
        setState({
            addons: produce(addons, (draft) => {
                const newQuantity = quantity + 1;
                draft[addon.id].quantity = newQuantity;
                setQuantity(newQuantity);
            }),
        });
    };

    return (
        <div>
            <div>
                <button style={spinnerStyle} onClick={handleDecrease}>
                    -
                </button>
                <span style={{ marginLeft: 8, marginRight: 8 }}>{quantity}</span>
                <button style={spinnerStyle} onClick={handleIncrease}>
                    +
                </button>
            </div>
        </div>
    );
};
